import { useState, useEffect } from "react";
import { TabTwo } from "./TabTwo";
import { TabThree } from "./TabThree";
import Profile from "../assets/image/monetization_on.png";
import Paygap from "../assets/image/work.png";
import TaxAvoidance from "../assets/image/assured_workload.png";
import excla from '../assets/image/Excla.png'

import React from "react";
import { TabNull } from "./TabNull";
import { useMediaQuery, Typography, Box } from "@mui/material";

export const Tabs = () => {
  const [hideTabsOnMobile, setHideTabsOnMobile] = useState(false);
  const [activeTab, setActiveTab] = useState(null); // 👈 no active tab at first
  const isDesktop = useMediaQuery("(min-width:768px)");
  const isMobile = !isDesktop;
  const [hasResults, setHasResults] = useState(false);
  const [productsData, setProductsData] = useState([]);
  const [productsLoading, setProductsLoading] = useState(true);
  const getSearchLabel = () => {
    if (activeTab === 0) {
      return "Search by brand or product name";
    }
    switch (activeTab) {
      case 1:
        return "Search by pay gap details";
      case 2:
        return "Search by tax avoidance info";
      default:
        return "Search by brands, products or type";
    }
  };
  useEffect(() => {
    let isMounted = true;
    let data = [];
    async function load() {

      const formatData = (apiData) => {
        return apiData.map((item, index) => ({
          id: index,
          label: `${item.Brand || ""} ${item["Product Name"] || ""} ${item.Type || ""}`.trim(),
          value: `${item.Brand || ""} ${item["Product Name"] || ""} ${item.Type || ""}`.trim(),
          brand: item.Brand || "",
          productName: item["Product Name"] || "",
          type: item.Type || "",
          category: item.Category || "",
          profitMargin: item["Profit Margin"] || item["Profit Margin "] || "N/A",
          productionYear: item["Production Year"] || item["Production Year "] || "N/A",
          image: item["Link to Product Pictures"] || "",
        }));
      };

      const fetchData = async (offset = 0) => {
        try {
          const res = await fetch(`${process.env.REACT_APP_API_URL || "https://api.the-aysa.com"}/get-profit-margin-data/?limit=3000&offset=${offset}`);
          const result = await res.json();
          data = data.concat(result.results);

          const formatted = formatData(data || []);
          if (isMounted) {
            setProductsData(formatted);
            setProductsLoading(false);
          }

        } catch (err) {
          if (isMounted) setProductsLoading(false);
        }
      };

      const res = await fetch(`${process.env.REACT_APP_API_URL || "https://api.the-aysa.com"}/get-profit-margin-data/?limit=1000&offset=0`);
      const countData = await res.json();
      data = data.concat(countData.results); 

      const formatted = formatData(data || []);
      if (isMounted) {
        setProductsData(formatted);
        setProductsLoading(false);
      }

      const totalCount = countData.count;

      let i = 1000;
      while (i < totalCount) {
        await fetchData(i);
        i += 3000;
      }
    }
    load()
    return () => {
      isMounted = false;
    };
  }, []);
  const tabs = [
    {
      label: "Profit Margins",
      text: "Reveal any product’s profit margin.",
      icon: <img src={Profile} alt="Profile" />,
      content: (
        <TabNull
          searchLabel={getSearchLabel()}
          onResults={setHideTabsOnMobile}
          onSearchResultsFound={setHasResults}
          allProductsData={productsData}
          initialDataLoading={productsLoading}
        />
      ),
    },
    {
      label: "Pay Gap",
      text: "Expose the CEO–worker pay gap",
      icon: <img src={Paygap} alt="Paygap" />,
      content: <TabTwo
        onSearchResultsFound={setHasResults}
      />,
    },
    {
      label: "Tax Avoidance",
      text: "Uncover corporate America’s tax avoidance.",
      icon: <img src={TaxAvoidance} alt="TaxAvoidance" className="tab-img" />,
      content: <TabThree
        onSearchResultsFound={setHasResults}
      />,
    },
  ];

  return (
    <>
      {/* <Box className="headerSyletext">
        <Typography variant="h3" sx={{ mb: 0, color: "#181818" , fontWeight:"800" }}>
          See what brands don’t want you to know.
        </Typography>

        <Typography variant="h6" sx={{ mb: 0, color: "#181818" }}>
          Pick the product. Get the truth.
        </Typography>
      </Box> */}

      <div className="header-main">



        {!hasResults && (
          <Box className="headerSyletext">
            <Typography variant="h3" sx={{ mb: 0, color: "#181818", fontWeight: "600" }}>
              See what brands don’t want you to know.
            </Typography>
            <Typography variant="h6" sx={{ mb: 0, color: "#181818" }}>
              Pick the product. Get the truth.
            </Typography>
          </Box>
        )}


        <div className="tab-content" id="below-render-search">
          {activeTab === null ? (
            <TabNull
              searchLabel={getSearchLabel()}
              onResults={setHideTabsOnMobile}
              onSearchResultsFound={setHasResults}
              allProductsData={productsData}
              initialDataLoading={productsLoading}
            />
          ) : (
            tabs[activeTab].content
          )}
        </div>

        {!hasResults && (
          <div className="tab-wrapper">
            {/* Tab Buttons */}
            <div
              className={`tab-buttons ${isMobile && hideTabsOnMobile ? "hide" : ""
                }`}
            >
              {tabs.map((tab, index) => (
                <div
                  key={index}
                  className={`outer-circle ${activeTab !== null && activeTab === index ? "active" : ""
                    }`}
                  onClick={() => setActiveTab(index)}
                >
                  <span className="tabsIcons">{tab.icon}</span>
                  <div>
                    <span className="flex items-center">{tab.label}
                      <img src={excla} className="img-excla ms-2" />
                    </span>
                    <span className="text-start">{tab.text} </span>
                  </div>
                </div>
              ))}
            </div>

            {/* Tab Content */}

          </div>
        )}

      </div>

    </>
  );
};
